import { withBookingFunnelSessionKey } from '@/services/bookingFunnelTracker';

export default {
  namespaced: true,
  state: {
    booking: {
      company_id: null,
      party_size: 2,
      reservation_date: new Date().toISOString().slice(0, 10),
      preferred_time: '19:00',
      selected_slot: null,
      guest_fname: '',
      guest_lname: '',
      guest_phone: '',
      guest_email: '',
      commission_partner_email: '',
      occasion: '',
      special_requests: '',
      hold_token: '',
      hold_expires_at: '',
      reservation: null,
    },
  },
  getters: {
    getRestaurantBooking(state) {
      return state.booking;
    },
  },
  mutations: {
    patchRestaurantBooking(state, payload) {
      state.booking = { ...state.booking, ...payload };
    },
  },
  actions: {
    updateRestaurantBooking({ commit }, payload) {
      commit('patchRestaurantBooking', payload);
    },
    async getRestaurantAvailability(_, payload) {
      const params = new URLSearchParams(payload);
      const response = await fetch(`${process.env.VUE_APP_BASEURL}public/restaurant/availability?${params.toString()}`);
      const data = await response.json();
      if (!response.ok) data.__error = true;
      return data;
    },
    async createRestaurantReservation(_, payload) {
      const reservationPayload = withBookingFunnelSessionKey(payload, payload.company_id, 'restaurant');
      const response = await fetch(`${process.env.VUE_APP_BASEURL}public/restaurant/reservations`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reservationPayload),
      });
      const data = await response.json();
      if (!response.ok) data.__error = true;
      return data;
    },
    async createRestaurantHold(_, payload) {
      const response = await fetch(`${process.env.VUE_APP_BASEURL}public/restaurant/holds`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok) data.__error = true;
      return data;
    },
    async releaseRestaurantHold(_, payload) {
      const response = await fetch(`${process.env.VUE_APP_BASEURL}public/restaurant/holds/release`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok) data.__error = true;
      return data;
    },
  },
};
